import MapService from "./MapService";
import CompareService from "./CompareService";

export default class ServiceFactory {
  static getDataService() {
    return new MapService();
  }

  static getMapConfigService() {
    return new MapService();
  }

  static getCompareService() {
    return new CompareService();
  }
}
